module.exports = __webpack_public_path__ + "static/media/studio.cccfe867.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/studio.png
// module id = 16
// module chunks = 0